import React from 'react'
import {Controller} from 'react-hook-form'
import {Label} from 'lib/ui/typography'
import {useTownhallTemplate} from 'Event/template/Townhall'
import HTMLEditor, {HTMLEditorContainer} from 'lib/ui/form/HTMLEditor'
import {useConfig} from 'organization/Event/Configurable'
import ImageAssetUploader from 'lib/asset/ImageAssetUploader'
import {useAttendeeVariables} from 'Event'

export default function Settings() {
  const {
    form: {control},
  } = useConfig()
  const {hero} = useTownhallTemplate()

  const v = useAttendeeVariables()
  return (
    <>
      <Label>Image</Label>
      <Controller
        name="hero.image"
        control={control}
        defaultValue={hero.image}
        render={({onChange, value}) => (
          <ImageAssetUploader
            onChange={onChange}
            value={value}
            uploadLabel="Upload"
            canResize
            uploadInputProps={{
              'aria-label': 'hero image upload',
            }}
            disableAutoRemove
          />
        )}
      />
      <Label>Description</Label>
      <HTMLEditorContainer>
        <Controller
          name="hero.body"
          defaultValue={v(hero.body)}
          control={control}
          render={({value, onChange}) => (
            <HTMLEditor data={value} onChange={onChange} />
          )}
        />
      </HTMLEditorContainer>
    </>
  )
}
